import { Link } from 'react-router-dom';
import { useState } from 'react';
import { api, readErr } from '@/lib/api';
import { AuthFrame } from '@/pages/Login';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from '@/lib/toast';

export default function ForgotPassword() {
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const requestOtp = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post('/auth/forgot-password', { email });
            toast.success('If that email exists, a code is on its way.');
            setStep(2);
        } catch (err) {
            toast.error(readErr(err, 'Request failed'));
        } finally { setLoading(false); }
    };

    const reset = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post('/auth/reset-password', { email, code, new_password: newPassword });
            toast.success('Password updated — sign in now');
            window.location.href = '/login';
        } catch (err) {
            toast.error(readErr(err, 'Reset failed'));
        } finally { setLoading(false); }
    };

    return (
        <AuthFrame
            title={step === 1 ? 'Forgot password' : 'Enter the code'}
            subtitle={step === 1 ? "We'll send a 6-digit code." : 'Valid for 15 minutes.'}
        >
            {step === 1 ? (
                <form onSubmit={requestOtp} className="space-y-5" data-testid="forgot-form">
                    <div>
                        <Label htmlFor="femail" className="text-slate-300 text-xs uppercase tracking-wider">Email</Label>
                        <Input id="femail" type="email" required autoFocus
                            value={email} onChange={(e) => setEmail(e.target.value)}
                            className="mt-2 bg-transparent border-b border-marigold/20 border-t-0 border-l-0 border-r-0 rounded-none px-0 focus-visible:ring-0 focus-visible:border-marigold text-parchment h-11"
                            data-testid="forgot-email"
                        />
                    </div>
                    <Button type="submit" disabled={loading} data-testid="forgot-submit"
                        className="w-full bg-marigold text-obsidian hover:bg-marigold-hover rounded-none h-11 font-medium">
                        Send OTP
                    </Button>
                </form>
            ) : (
                <form onSubmit={reset} className="space-y-5" data-testid="reset-form">
                    <div>
                        <Label className="text-slate-300 text-xs uppercase tracking-wider">Code</Label>
                        <Input required value={code} onChange={(e) => setCode(e.target.value)}
                            maxLength={6}
                            className="mt-2 bg-transparent border-b border-marigold/20 border-t-0 border-l-0 border-r-0 rounded-none px-0 focus-visible:ring-0 focus-visible:border-marigold text-parchment h-11 font-mono tracking-widest"
                            data-testid="reset-code"
                        />
                    </div>
                    <div>
                        <Label className="text-slate-300 text-xs uppercase tracking-wider">New password</Label>
                        <Input type="password" required value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
                            className="mt-2 bg-transparent border-b border-marigold/20 border-t-0 border-l-0 border-r-0 rounded-none px-0 focus-visible:ring-0 focus-visible:border-marigold text-parchment h-11"
                            data-testid="reset-new-password"
                        />
                    </div>
                    <Button type="submit" disabled={loading} data-testid="reset-submit"
                        className="w-full bg-marigold text-obsidian hover:bg-marigold-hover rounded-none h-11 font-medium">
                        Reset password
                    </Button>
                </form>
            )}
            <p className="mt-6 text-sm text-slate-400 text-center">
                <Link to="/login" className="text-marigold hover:text-marigold-50">Back to sign in</Link>
            </p>
        </AuthFrame>
    );
}
